export class CountryState {
  private readonly state: string;
  private readonly propertiesKey: string;

  constructor(state: string, propertiesKey: string) {
    this.state = state;
    this.propertiesKey = propertiesKey;
  }

  public getState(): string {
    return this.state;
  }

  public getPropertiesKey(): string {
    return this.propertiesKey;
  }

  public toString(): string {
    return this.state;
  }
}

const AR = new CountryState('AR', 'AR Argentina');
const BO = new CountryState('BO', 'BO Bolivia');
const BR = new CountryState('BR', 'BR Brazil');
const CL = new CountryState('CL', 'CL Chile');
const CO = new CountryState('CO', 'CO Colombia');
const EC = new CountryState('EC', 'EC Ecuador');
const GP = new CountryState('GP', 'GP Guadeloupe');
const MQ = new CountryState('MQ', 'MQ Martinique');
const PE = new CountryState('PE', 'PE Peru');
const TT = new CountryState('TT', 'TT Trinidad and Tobago');
const UY = new CountryState('UY', 'UY Uruguay');
const VE = new CountryState('VE', 'VE Venezuela');
const US = new CountryState('US', 'US United States of America');
const MX = new CountryState('MX', 'MX Mexico');
const CA = new CountryState('CA', 'CA Canada');

const members: Map<string, CountryState> = new Map([
  [AR.toString(), AR],
  [BO.toString(), BO],
  [BR.toString(), BR],
  [CL.toString(), CL],
  [CO.toString(), CO],
  [EC.toString(), EC],
  [GP.toString(), GP],
  [MQ.toString(), MQ],
  [PE.toString(), PE],
  [TT.toString(), TT],
  [UY.toString(), UY],
  [VE.toString(), VE],
  [US.toString(), US],
  [MX.toString(), MX],
  [CA.toString(), CA]
]);

export function getCountryStateList(): { state: string; propertiesKey: string }[] {
  return Array.from(members.values()).map((cs) => ({
    state: cs.getState(),
    propertiesKey: cs.getPropertiesKey()
  }));
}
